import router from '@core/router';
import store from '@core/store';

export const replaceQueryParam = (key, value) => {
    const currentUrl = window.location.href;
    const url = new URL(currentUrl);

    if (value === null || value === undefined) {
        url.searchParams.delete(key);
    } else {
        url.searchParams.set(key, value);
    }

    const newUrl = url.toString();

    if (newUrl !== currentUrl) {
        window.history.replaceState(window.history.state, '', newUrl);
        const { route } = router.resolve(newUrl.substring(url.origin.length));
        store.dispatch('app/setCurrentRoute', route);
    }
};

export const getQueryParam = key => {
    const currentUrl = window.location.href;

    if (!currentUrl || !currentUrl.includes('?')) {
        return null;
    }

    const params = new URLSearchParams(currentUrl.split('?')[1]);
    return params.get(key) || null;
};

export const getQueryParams = () => {
    const currentUrl = window.location.href;

    if (!currentUrl || !currentUrl.includes('?')) {
        return {};
    }

    const params = new URLSearchParams(currentUrl.split('?')[1]);
    let queryParams = {};

    for (let [key, value] of params.entries()) {
        queryParams[`${key}`] = value;
    }

    return queryParams;
};
